import { delay, put, select, spawn, take } from 'redux-saga/effects';
import { dissoc } from 'ramda';
import * as types from '../constants/ActionTypes';
import { TYPING_COMPLETE } from '../constants/AppConstants';
import * as endpoints from '../constants/RabbitQueueEndpoints';
import * as chatActions from '../actions/chatActions';
import * as pdfActions from '../actions/pdfActions';


function* delayTypingComplete(chatId, typistUserId) {
  yield delay(TYPING_COMPLETE);
  yield put(chatActions.typingComplete(chatId, typistUserId));
}

export const endpoint = endpoints.QUEUE_EVENT_NOTIFICATIONS;

export const handler = (emit, message) => {
  const body = JSON.parse(message.body);
  emit({ type: body.eventType, payload: dissoc('eventType', body) });
};

export function* read(queue) {
  while (true) {
    const action = yield take(queue);

    if (action.type === types.USER_INVITED_TO_CHANNEL) {
      yield put(chatActions.getChats([action.payload.chatId]));
    }

    if (action.type === types.USER_ADDED_TO_CHANNEL) {
      yield put({ type: types.ADD_USERS_TO_CHANNEL_SUCCESS, payload: action.payload });
    }

    if (action.type === types.USER_LEFT_CHANNEL) {
      const { senderId, chatId } = action.payload;
      yield put(chatActions.userLeftChannel(senderId, chatId));
    }

    if (action.type === types.USER_MENTIONED) {
      const { chatId, messageId } = action.payload;
      yield put(chatActions.mentionUser(chatId, messageId));
    }

    if (action.type === types.USER_CREATED) {
      const { user } = action.payload;
      yield put(chatActions.userCreated(user));
    }

    if (action.type === types.USER_UPDATED) {
      const { user } = action.payload;
      yield put(chatActions.userUpdated(user));
    }

    if (action.type === types.USER_STATUS_CHANGED) {
      const { senderId, status } = action.payload;
      yield put(chatActions.userStatusChanged(senderId, status));
    }

    if (action.type === types.START_PUBLIC_CHANNEL) {
      yield put({
        type: types.START_PUBLIC_CHANNEL,
        payload: { [action.payload.publicChannel.id]: action.payload.publicChannel },
      });
    }

    if (action.type === types.TYPING_RECEIVED) {
      const { chatId, typistUserId } = action.payload.typing;
      yield put(chatActions.typingReceived(chatId, typistUserId));
      yield spawn(delayTypingComplete, chatId, typistUserId);
    }

    if (action.type === types.SEND_TO_INBOX_RESULT) {
      const { success, chatId } = action.payload; // failedCount is also returned with the number of failed attachments
      const chat = yield select(state => state.chats[chatId]);

      if (success) {
        yield put(pdfActions.successfulExportToInbox(chat));
        yield put(chatActions.deselectMessages(chatId));
      } else {
        yield put(pdfActions.failExportToInbox(chat));
      }
    }
  }
}
